document.addEventListener("DOMContentLoaded", () => {
    const selector = ".text-script-effect, .handwriting-write";
    const defaultSpeed = 65;
    const defaultDelay = 120;
    const isDiviVisualBuilder =
        document.body.classList.contains("et-fb") ||
        document.body.classList.contains("et-fb-root-ancestor") ||
        document.querySelector("#et-fb-app, .et-fb-app, .et-fb-root-ancestor") !== null;

    if (isDiviVisualBuilder) return;

    const elements = Array.from(document.querySelectorAll(selector));

    if (!elements.length) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const getTextTarget = (element) => {
        if (!element.classList.contains("et_pb_module")) return element;

        return element.querySelector(".et_pb_text_inner, .et_pb_blurb_description, .et_pb_module_header") || element;
    };

    const getNumber = (value, fallback) => {
        const number = Number.parseFloat(value);

        return Number.isFinite(number) ? number : fallback;
    };

    const splitWords = (text) => text.match(/\S+|\s+/g) || [];

    const shouldSkipNode = (node, target) => {
        const parent = node.parentElement;

        if (!parent || !target.contains(parent)) return true;

        return parent.closest("script, style, noscript, .script-effect-word, .script-effect-character") !== null;
    };

    const getTextNodes = (target) => {
        const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, {
            acceptNode(node) {
                if (shouldSkipNode(node, target) || !node.nodeValue.trim()) {
                    return NodeFilter.FILTER_REJECT;
                }

                return NodeFilter.FILTER_ACCEPT;
            },
        });

        const nodes = [];

        while (walker.nextNode()) {
            nodes.push(walker.currentNode);
        }

        return nodes;
    };

    const buildAnimatedFragment = (text, delay, speed, characterIndex) => {
        const fragment = document.createDocumentFragment();
        let nextCharacterIndex = characterIndex;

        splitWords(text).forEach((part) => {
            if (/^\s+$/.test(part)) {
                fragment.append(document.createTextNode(part));

                return;
            }

            const word = document.createElement("span");
            word.className = "script-effect-word";

            Array.from(part).forEach((character) => {
                const characterElement = document.createElement("span");
                characterElement.className = "script-effect-character";
                characterElement.textContent = character;
                characterElement.style.setProperty("--script-character-delay", `${delay + nextCharacterIndex * speed}ms`);
                word.append(characterElement);
                nextCharacterIndex += 1;
            });

            fragment.append(word);
        });

        return { fragment, characterIndex: nextCharacterIndex };
    };

    const prepareElement = (element) => {
        const target = getTextTarget(element);
        const textNodes = getTextNodes(target);
        const text = target.textContent.trim();

        if (!text || !textNodes.length) return null;

        const speed = Math.max(18, getNumber(element.dataset.scriptEffectSpeed, defaultSpeed));
        const delay = Math.max(0, getNumber(element.dataset.scriptEffectDelay, defaultDelay));

        element.classList.add("is-script-ready");

        let characterIndex = 0;

        textNodes.forEach((node) => {
            const result = buildAnimatedFragment(node.nodeValue, delay, speed, characterIndex);

            characterIndex = result.characterIndex;
            node.replaceWith(result.fragment);
        });

        const duration = delay + characterIndex * speed + 420;

        return { element, duration };
    };

    const preparedElements = elements.map(prepareElement).filter(Boolean);

    if (reduceMotion) {
        preparedElements.forEach(({ element }) => {
            element.classList.add("is-script-writing");
            element.classList.add("is-script-complete");
        });

        return;
    }

    const startWriting = (element, duration) => {
        element.classList.add("is-script-writing");

        window.setTimeout(() => {
            element.classList.add("is-script-complete");
        }, duration);
    };

    if (!("IntersectionObserver" in window)) {
        preparedElements.forEach(({ element, duration }) => startWriting(element, duration));

        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const item = preparedElements.find(({ element }) => element === entry.target);

                if (item) {
                    startWriting(item.element, item.duration);
                }

                observer.unobserve(entry.target);
            });
        },
        {
            root: null,
            rootMargin: "0px 0px -18% 0px",
            threshold: 0.01,
        },
    );

    preparedElements.forEach(({ element }) => observer.observe(element));
});
